import { EligibilityMaritalStatusScreen } from "@/interactors/EligibilityMaritalStatus";

export default function MaritalStatus() {
  return <EligibilityMaritalStatusScreen />;
}
